( function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .controller( 'LotUnallocateDialogController', LotUnallocateDialogController );

    LotUnallocateDialogController.$inject = [ 'entity', '$uibModalInstance', 'LotCustomService', 'ToastrService' ];

    function LotUnallocateDialogController( entity, $uibModalInstance, LotCustomService, ToastrService ) {

        var vm = this;

        vm.lot = entity;

        vm.close = close;
        vm.confirmUnallocate = confirmUnallocate;

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmUnallocate() {
            vm.isSaving = true;
            LotCustomService.releaseLot( vm.lot.id ).then( function() {
                $uibModalInstance.close( true );
                vm.isSaving = false;
            }, function( error ) {
                if( error.status !== "404" ) {
                    ToastrService.error( "Something went wrong.", "Error!" );
                }
                console.log( error.message );
                vm.isSaving = false;
            });
        }
    }
})();
